<script>
    import { fade } from 'svelte/transition';
    import {link , push} from 'svelte-spa-router'
    import { fetchDataBot }  from '../../api.js';
    import UserStore from '../../stores/user';
    import { _ } from "svelte-i18n";
    import { onMount } from 'svelte';
    import Header from '../../components/Header.svelte';
    import TopInfo from '../../components/TopInfo.svelte';  
    import Preloader from '../../components/Preloader.svelte'; 


    
    export let params;

    let base_id = params.base_id;
    let table_id = params.table_id

    let isLoading = false;
    let data = [];
    
    onMount(async() => {

        if (!$UserStore || !$UserStore.data){
            push('/login');
            return;
        }       
        
        fetchPage();
        
    })

    async function fetchPage() {

        isLoading = true;
        let postData = {};
        postData.action = 'table';
        postData.base_id = base_id;
        postData.table_id = table_id
        postData.token = $UserStore.data;

        let response = await fetchDataBot(postData);
        if (response.data) {



            data = [...response.data]
            data = data.map((item) => {
                const newFields = {};

                for (const key in item.fields) {
                    if (typeof item.fields[key] === 'string') {
                        newFields[key] = item.fields[key].replace(/\n/g, '<br>');
                    } else {
                        newFields[key] = item.fields[key];
                    }
                }

                return {
                    ...item,
                    fields: newFields
                };
            });

            data = [...data]
            

        }

        isLoading = false;

    }


    
</script>

<div class="page-container" transition:fade={{ delay: 250, duration: 300 }}>
    <Preloader {isLoading}/>
    <Header />
    <div class="page">

        <TopInfo />   
        
        <div class="dash-list">        
            <div class="orders-top">
                <div class="orders-top-up">
                    <h1 class="text-[20px] font-bold">{$_('bot.table.title')}</h1>
                    <span on:click={()=> { } } class="create_button"><span>{$_('bot.table.add')}</span></span>
                </div>
                <div class="locations_desc">{$_('bot.table.desc')}</div>
                {#if data.length}
                <div class="table table-shipments">
                    <div class="head">
                        {#each Object.keys(data[0].fields) as item,index}
                        <div>{item}</div>
                        {/each}
                    </div>
                    {#each data as item,index}
                    <div class="content">
                        {#each Object.keys(item.fields) as item_field,index_field}
                        <div class="input_con flex content-start justify-center">
                            {@html item.fields[item_field]}
                        </div>
                        {/each}                        
                    </div>
                    {/each}
                </div>
                {/if}
            </div>
        </div>
    </div>
</div>
